import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: 'h-6 w-6',
};

const QuoteIcon = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <path
            d="M2 9.352c0 1.873.849 2.943 1.683 3.943.031 1 .085 1.668-.333 3.183 1.748-.558 2.038-.778 3.008-1.374 1 .244 1.474.381 2.611.491-.094.708-.081 1.275.055 2.023-.752-.06-1.528-.178-2.33-.374-1.397.857-4.481 1.725-6.649 2.115.811-1.595 1.708-3.785 1.661-5.312-1.091-1.305-1.706-2.985-1.706-4.695 0-4.826 4.719-8.352 10-8.352 5.237 0 9.977 3.484 9.998 8.318-.644-.175-1.322-.277-2.021-.314-.229-3.34-3.713-6.004-7.977-6.004-4.411 0-8 2.85-8 6.352zm20.883 10.169c-.029 1.001.558 2.435 1.088 3.479-1.419-.258-3.438-.824-4.352-1.385-.772.188-1.514.274-2.213.274-3.865 0-6.498-2.643-6.498-5.442 0-3.174 3.11-5.467 6.546-5.467 3.457 0 6.546 2.309 6.546 5.467 0 1.12-.403 2.221-1.117 3.074zm-5.664-4.521h-2.219v2.222h.889c0 .491-.347 1.096-.887 1.3l.221.478c1.167-.231 1.996-1.09 1.996-2.358v-1.642zm3.115 0h-2.219v2.222h.885c0 .491-.348 1.096-.888 1.3l.222.478c1.167-.231 2-1.09 2-2.358v-1.642zm-7.561-4v-2.777h-1.111c0-.615.434-1.371 1.108-1.625l-.275-.598c-1.459.289-2.495 1.363-2.495 2.948v2.052h2.773zm-4 0v-2.777h-1.105c0-.615.435-1.371 1.109-1.625l-.277-.598c-1.458.289-2.5 1.363-2.5 2.948v2.052h2.773z"
            fill="currentColor"
        />
    </svg>
);

QuoteIcon.propTypes = propTypes;
QuoteIcon.defaultProps = defaultProps;

export default React.memo(QuoteIcon);
